import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/estimate-list';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateTimeComponent from "../components/aggregate-time";
import normalizeNumber from "../../import/normalize/normalize-number";
import FieldTimeReportViewInImport from "../../import/view-in-preview/timereport-in-import";

export default class EstimateField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ESTIMATE;
        this.valueType = gd.const.fields.valueType.FLOAT;
        this.formulaCompatible = true;
    }

    get sortHintMessage() {
        return 'Sort by estimate time';
    }

    getCsvValue(item) {
        return item.estimate ;
    }

    getValue(item) {return item.estimate}
    getFormulaValue(item) {return gd.utils.Time.roundHours(this.getValue(item))}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.estimate || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {return AggregateTimeComponent.bind(null, this.getAggregateOptions());}


    // IMPORT

    normalizeCSVValue(value) {
        value = normalizeNumber(value);

        // 0 supported
        if (!_.isNil(value)) {
            return value;
        }
        return null;
    }

    getComponentViewInImport() {
        return FieldTimeReportViewInImport;
    }

}
